module.exports = __webpack_public_path__ + "6e9760427d887ca7889244ebc332cab2.glb";